import React, { Component } from 'react';
import ReportsLayout from '../../templates/reports';
import Expenses from '../../elements/reports/expenses';
import Loading from './../../elements/loading';

class ReportsExpenses extends Component{
	render (){
		const { reports, revision } = this.props;
		const { expenses } = reports;
		return (
			(revision.isFetching || expenses.isFetching) ? <Loading/>:<Expenses {...this.props}/>
		)
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;
		//this.props.fetchRevisions(modality, state, municipality);
		this.props.reportsExpenses(modality, state, municipality);
	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;

		if(newprops.match.params !== this.props.match.params) {
			//this.props.fetchRevisions(modality, state, municipality);
			this.props.reportsExpenses(modality, state, municipality);
		}
	}
}

export default ReportsLayout(ReportsExpenses, {subnav: 2});


// WEBPACK FOOTER //
// ./src/layouts/reports/expenses.jsx